import React, { useState } from 'react'
import {Button,Modal} from 'react-bootstrap'

function ModalBringYourOwnChallenges () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div>
            <Button variant="primary" onClick={handleShow}>
                Learn more
            </Button>
            {/* <a href="/" className="btn btn-link right-icon" >Learn more <i className="icon icon-minimal-right"></i></a> */}
    
            <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Bring Your Own Challenges</Modal.Title>
            </Modal.Header>
            <Modal.Body>Ada ide menarik lainnya yang berkaitan dengan dunia konstruksi, tapi tidak termasuk empat kategori di atas? 
                Jangan takut untuk mendaftar! Tentukan sendiri tantanganmu, dan ciptakan solusinya!</Modal.Body>
            {/* <Modal.Footer></Modal.Footer> */}
            </Modal>
        </div>
    );
}


export default ModalBringYourOwnChallenges
